import { KeyboardArrowDown } from "@mui/icons-material";
import { Button, CircularProgress, Dialog, InputBase, MenuItem, Select } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const DeleteUserAccountModal = ({
  open,
  setOpen,
  loader,
  deleteUser,

}) => {
    const [call_routes, setCallRoutes] = useState(null)
    

    const [auth, setAuth] = useState("");

  const navigate = useNavigate()
  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"sm"}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.2)" }, // Adjust opacity here
      }}
    >
      <div className="lg:px-8 px-4 py-14">
        <div className="lg:text-[20px] text-[#030229]  text-[15px] font-semibold  text-center mb-4">
          Delete User Account!
        </div>

        {(call_routes && call_routes.length > 0) && (
            <div className="lg:text-[15px] text-[14px] text-center mt-2   mb-4">
            You have {call_routes && call_routes.length} call routes 
            ({call_routes.filter((e) => e)
  .map((e, index) => (
    <span onClick={()=> navigate('/dashboard/call-route/'+e.routeId.S) } key={index} className="text-blue-700 hover:underline cursor-pointer">
      {e.name.S}
    </span>
  ))
  .reduce((prev, curr) => [prev, ', ', curr])}) 
            currently using this recording. Please remove these dependencies before deleting this channel.
          </div>
        )}

        <div hidden = {call_routes && call_routes.length > 0 ? true : false}  className="lg:w-full my-3">
          <InputBase
            placeholder="Type DELETE to Confirm"
            value={auth}
            onChange={(e) => 
              setAuth(e.target.value)
            }
            sx={{
              bgcolor: "#F7F7F8",
              width: "100%",
              px: 2,
              py: 1,
              fontSize: { lg: "16px", xs: "14px" },
            }}
          />
        </div>
        <div className="flex justify-center">
          <div className="space-y-5 ">
            <div className="flex justify-center pt-6 pb-4 space-x-2">
              <Button
                sx={{
                  textTransform: "none",
                  color: "#605BFF",
                  bgcolor: "white",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  border: "1px solid rgba(96,91,255,0.1)",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                Cancel
              </Button>


              {call_routes && call_routes.length > 0 ? (<></>) : (
              <Button
                sx={{
                  textTransform: "none",
                  bgcolor: "rgba(236,72,92,0.1)",
                  color: "rgba(236,72,92,1)",
                  py: "4px",
                  px: "40px",
                  borderRadius: "7px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                disabled={auth === "DELETE" ? false : true}
                onClick={() => {
                    deleteUser()
                }}
              >
                {loader ? (
                  <CircularProgress size={"1.3rem"} sx={{ color: "white" }} />
                ) : (
                  " Delete"
                )}
              </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default DeleteUserAccountModal;
